module.exports = __webpack_public_path__ + "57fa85b982089222c934d0c9b4b9cd55.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-panel-1080.webp.png
// module id = 469
// module chunks = 0